<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="card-title">
            <div class="row">
              <div class="col-6">
                <h4>
                  <router-link :to="{name:'question-bank'}">
                    <i class="fas fa-arrow-left"></i>
                  </router-link>
                  Question Bank Category
                </h4>
              </div>

              <div class="col-6 text-right">
                <button class="btn btn-primary" @click="addCategory">
                    <span>
                      <i class="fas fa-plus mr-2"></i>
                    </span>
                  Add
                </button>
              </div>


            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <table class="table">
                <thead>
                <th>Title</th>
                <th>Status</th>
                <th>Action</th>
                </thead>
                <tbody v-if="categories.length > 0">
                <tr v-for="(category, index) of categories" :key="index">
                  <td>{{ category.title }}</td>
                  <td>
                      <span>
                        <i
                            v-if="category.is_active"
                            class="fas fa-check text-success"
                        ></i>
                        <i v-else class="fas fa-ban text-danger"></i>
                      </span>
                  </td>
                  <td>
                    <b-dropdown
                        size="sm"
                        variant="link"
                        toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        no-caret
                        right
                        no-flip
                    >
                      <template v-slot:button-content>
                        <slot>
                                                        <span>
                                                                    <i class="flaticon-more-1"></i>
                                                                  </span></slot>
                      </template>
                      <!--begin::Navigation-->
                      <div class="navi navi-hover ">


                        <b-dropdown-text tag="div" class="navi-item">
                          <a href="#" class="navi-link" @click="editCategory(category)">
                                                            <span class="navi-icon">
                                                              <i class="flaticon-edit"></i>
                                                            </span>
                            <span class="navi-text"> Edit </span>
                          </a>
                        </b-dropdown-text>

                        <b-dropdown-text tag="div" class="navi-item">
                          <a href="#" class="navi-link" @click="deleteCategory(category.id)">
                                                            <span class="navi-icon">
                                                              <i class="fas fa-trash"></i>
                                                            </span>
                            <span class="navi-text">  Delete</span>
                          </a>
                        </b-dropdown-text>

                      </div>
                      <!--end::Navigation-->
                    </b-dropdown>

                  </td>
                </tr>
                </tbody>
                <tbody v-else>
                <td></td>
                <td></td>
                <td>No data found</td>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <create-and-update
        ref="question-bank-category"
        :dialog="dialog"
        @refresh_list="getCategories"
    ></create-and-update>
  </div>
</template>
<script>
import CreateAndUpdate from "./CreateAndUpdate";
import QuestionBankCategoryService from "@/core/services/quiz/question-bank/category/QuestionBankCategoryService";

const categoryService = new QuestionBankCategoryService();

export default {
  components: {
    CreateAndUpdate,
  },
  data() {
    return {
      categories: [],
      dialog: false,
      category: {}
    };
  },
  mounted() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      this.dialog = false
      categoryService.paginate().then((response) => {
        this.categories = response.data.data;
      });
    },
    addCategory() {
      this.dialog = true
    },
    editCategory(category) {
      this.dialog = true
      this.$refs['question-bank-category'].setType(category)
    },
    deleteCategory(id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            categoryService.delete(id).then((response) => {
              this.getCategories()
            });
          }
        }
      });
    },
  },
};
</script>
